import oneLetterWeekdaysJapanese from "@utils/date/oneLetterWeekdaysJapanese";

/**
 *  日付から曜日を返す
 */
export const getDayOfTheWeek = (date: string | number | Date): string => {
  const dayIndex = new Date(date).getDay();
  return oneLetterWeekdaysJapanese[dayIndex];
};
